/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import { defineComponent, ref } from '@vue/composition-api';
import getConfigReceiverMixins, { getKeepAnimationMixins, getGlobalIconMixins } from '../config-provider/config-receiver.js';
import useTreeItem from './hooks/useTreeItem.js';
import Ripple from '../utils/ripple.js';
import 'vue';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';
import '@babel/runtime/helpers/defineProperty';
import '../hooks/useConfig.js';
import '../config-provider/useConfig.js';
import '../hooks/useLazyLoad.js';
import '../_common/js/utils/observe.js';
import './hooks/useItemEvents.js';
import './hooks/useRenderIcon.js';
import 'tdesign-icons-vue';
import '../hooks/useGlobalIcon.js';
import '../loading/index.js';
import '../loading/directive.js';
import 'lodash/isObject';
import 'lodash/mapKeys';
import 'lodash/isEqual';
import '../loading/plugin.js';
import '../loading/loading.js';
import '../loading/icon/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/isString';
import 'lodash/isNull';
import 'lodash/isUndefined';
import 'lodash/isNumber';
import 'lodash/isArray';
import '../utils/mixins.js';
import '../utils/dom.js';
import 'raf';
import '../utils/easing.js';
import '../utils/render-tnode.js';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../utils/transfer-dom.js';
import '../loading/props.js';
import '../config.js';
import '../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../loading/type.js';
import './util.js';
import './hooks/useRenderLabel.js';
import '../_chunks/dep-1461d230.js';
import 'lodash/isBoolean';
import '../checkbox/index.js';
import '../checkbox/group.js';
import 'lodash/intersection';
import '../checkbox/checkbox.js';
import '../checkbox/props.js';
import '../hooks/index.js';
import '../hooks/slots.js';
import '../hooks/useCommonClassName.js';
import '../hooks/useDefaultValue.js';
import '../hooks/useDestroyOnClose.js';
import '../hooks/useElementLazyRender.js';
import '../hooks/useFormDisabled.js';
import '../hooks/useResizeObserver.js';
import '../hooks/useVirtualScrollNew.js';
import '../hooks/useVModel.js';
import '../hooks/useImagePreviewUrl.js';
import '../_common/js/upload/utils.js';
import '../_common/js/log/log.js';
import '../checkbox/constants.js';
import '../checkbox/store.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '../checkbox/hooks/useKeyboardEvent.js';
import '../checkbox/checkbox-group-props.js';
import '../checkbox/type.js';
import './hooks/useRenderLine.js';
import './hooks/useRenderOperations.js';
import './hooks/useDraggable.js';
import 'lodash/throttle';

var keepAnimationMixins = getKeepAnimationMixins();
var treeItemProps = {
  node: {
    type: Object
  },
  rowIndex: {
    type: Number
  },
  treeScope: {
    type: Object
  },
  expandOnClickNode: {
    type: Boolean
  }
};
var TreeItem = defineComponent({
  name: "TTreeItem",
  props: treeItemProps,
  directives: {
    ripple: Ripple
  },
  mixins: [getConfigReceiverMixins("tree"), keepAnimationMixins, getGlobalIconMixins()],
  inject: {
    onDrag: {
      "default": void 0
    }
  },
  setup: function setup(props, context) {
    var treeItemRef = ref(null);
    var _useTreeItem = useTreeItem(props, context, treeItemRef),
      renderItemNode = _useTreeItem.renderItemNode;
    return {
      treeItemRef: treeItemRef,
      renderItemNode: renderItemNode
    };
  },
  render: function render(h) {
    if (typeof this.renderItemNode === "function") {
      return this.renderItemNode(h);
    }
    return null;
  }
});

export { TreeItem as default, treeItemProps };
//# sourceMappingURL=tree-item.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/tree/tree-item.js
// module id = null
// module chunks = 